import { setDangerouslyDisableStyles } from '@americanexpress/one-app-ducks';
import { fetchWithReporter, reportError } from '@americanexpress/one-identity-ducks';
import { fromJS } from 'immutable';
import { LOCATION_CHANGE } from 'react-router-redux';
import { v4 } from 'uuid';
import { MODULE_NAME, CREATE_NON_LOGGED_IN_AUTHENTICATION_TOKEN, AMEX_URL } from './constants';
import {
  getFaasUrl,
  isLogSuccess,
} from './selectors';

// Request headers
const HEADER_CONTENT_TYPE = 'Content-Type';
const METHOD_POST = 'POST';
export const ONE_DATA_CORRELATION_ID = 'one-data-correlation-id';
export const CONTENT_TYPE_JSON = 'application/json; charset=UTF-8';

export const SET_PURE_ROUTE = `modules/${MODULE_NAME}/core/SET_PURE_ROUTE`;
export const UPDATE_REDIRECTION = `module/${MODULE_NAME}/core/UPDATE_REDIRECTION`;

const INITIAL_STATE = fromJS({
  isPureRoute: false,
  redirection: {
    from: null,
    to: null,
  },
});

const canonicalize = (location) => {
  if (typeof location === 'string') {
    return (location.split('?', 1)[0] || '/').toLowerCase();
  }
  const { pathname } = location;
  return (pathname || '/').toLowerCase();
};

const ensureOneIdentityCorrelationId = (state) => {
  if (global.BROWSER && !state.getIn(['oneIdentityCorrelationId'])) {
    return state.setIn(['oneIdentityCorrelationId'], v4());
  }
  return state;
};

const buildInitialState = ({ req } = {}) => {
  const host = req?.forwarded?.host ?? req?.headers?.host ?? '';
  const protocol = req?.forwarded?.proto ?? req?.protocol ?? '';

  return INITIAL_STATE.merge({
    host,
    protocol,
  });
};
// eslint-disable-next-line default-param-last -- state needs to be first param
export default function coreReducer(state = buildInitialState(), action) {
  const { type, payload } = action;
  switch (type) {
    case SET_PURE_ROUTE:
      return state.setIn(['isPureRoute'], payload);

    case UPDATE_REDIRECTION:
      return state
        .update('redirection', (redirection) => redirection.merge(payload));

    case LOCATION_CHANGE:
      if (state.getIn(['redirection', 'from']) !== state.getIn(['redirection', 'to'])) {
        return state.setIn(['redirection', 'from'], canonicalize(payload));
      }
      return state;

    default:
      return ensureOneIdentityCorrelationId(state);
  }
}

coreReducer.buildInitialState = buildInitialState;

export const togglePureRoute = (isPureRoute) => (dispatch) => {
  dispatch({ type: SET_PURE_ROUTE, payload: isPureRoute });
  dispatch(setDangerouslyDisableStyles(isPureRoute));
};

const updateRedirection = (payload) => ({
  type: UPDATE_REDIRECTION,
  payload,
});

export const redirectUsing = (transition, destination, location) => (dispatch) => {
  const from = canonicalize(location);
  const to = canonicalize(destination);
  if (from !== to) {
    dispatch(updateRedirection({ from, to }));
  }

  const result = transition(destination);
  if (
    typeof result === 'function' || (typeof result === 'object' && result.type)
  ) {
    return dispatch(result);
  }

  return result;
};

export const errorReporterCreator = (collectionMethod, dispatch) => (error, otherData) => dispatch(
  reportError(error, {
    ...otherData,
    collectionMethod,
  })
);

export const rsvpRedirect = (oneTimeAuthenticationCode) => async (dispatch, getState) => {
  const state = getState();
  const errorReporter = errorReporterCreator('rsvpRedirect', dispatch);

  try {
    const response = await fetchWithReporter(`${getFaasUrl(state)}/${CREATE_NON_LOGGED_IN_AUTHENTICATION_TOKEN}`, {
      method: METHOD_POST,
      headers: {
        [HEADER_CONTENT_TYPE]: CONTENT_TYPE_JSON,
        [ONE_DATA_CORRELATION_ID]: v4(),
      },
      credentials: 'include',
      timeout: 9e3,
      errorReporter,
      logSuccess: isLogSuccess(state),
      body: JSON.stringify({
        oneTimeAuthenticationCode,
      }),
    }, state);

    const data = await response.json();

    if (response.status === 201) {
      const url = atob(data.encodedRedirectUrl);
      window.location.assign(url);
    } else {
      window.location.assign(AMEX_URL);
    }
  } catch (e) {
    window.location.assign(AMEX_URL);
  }
};
